module.exports = __webpack_public_path__ + "img/image (155).ba44f40a.jpg";